import { Component, OnInit } from '@angular/core';
import { ITooltipParams } from '@ag-grid-community/core';
import { ITooltipAngularComp } from 'ag-grid-angular';


@Component({
  selector: 'app-gridtooltip',
  templateUrl: './gridtooltip.component.html',
  styleUrls: ['./gridtooltip.component.css']
 
})
export class GridtooltipComponent implements ITooltipAngularComp {
 
  public params!: ITooltipParams;
  public valueToDisplay!: string;
  public isHeader!: boolean;
  public isGroupedHeader!: boolean;

  agInit(params: ITooltipParams): void {
    this.params = params;
    this.isHeader = params.rowIndex === undefined;
    this.isGroupedHeader = !!(params.colDef && (params.colDef as any).children);
    this.valueToDisplay = params.value.value
      ? params.value.value
      : '- Missing -';
  }
}
